import thesisCover from '../images/exjobb.png';
import jpArticleImage from '../images/JPposten.png';
import correnArticleImage from '../images/corren.png';

export const features = [
  'Projektledare för Ophelia AI från vision till produktion.',
  'Utbildad dataingenjör med fokus på AI och samhällsnytta.',
  'Bakgrund inom psykiatrisk vård och säkerhetsbranschen.',
  'Erfarenhet av eget företagande samt försäljning inom B2B och B2C.',
];

export const mediaMentions = [
  {
    title: 'Examensarbete i DiVA',
    text: 'Examensarbetet "Using AI to Prevent Domestic Violence" har haft över 450 nedladdningar i DiVA.',
    image: thesisCover,
    url: 'https://hj.diva-portal.org/smash/record.jsf?aq2=%5B%5B%5D%5D&c=1&af=%5B%5D&searchType=LIST_LATEST&sortOrder2=title_sort_asc&query=&language=sv&pid=diva2%3A1988672&aq=%5B%5B%5D%5D&sf=all&aqe=%5B%5D&sortOrder=author_sort_asc&onlyFullText=false&noOfRows=50&dswid=-1980',
    linkLabel: 'Läs i DiVA',
  },
  {
    title: 'Jönköpings-Posten',
    text: 'Projektet uppmärksammades i JP med fokus på teknikens potential att förebygga våld.',
    image: jpArticleImage,
    url: 'https://www.jp.se/2025-07-28/fran-ordningsvakt-till-ai-utvecklare-arya-vill-stoppa-valdet-med-ny-teknik/',
    linkLabel: 'Läs artikeln',
  },
  {
    title: 'Corren, Linköping',
    text: 'Corren beskrev hur Ophelia testats som beslutsstöd inom socialtjänstens arbete.',
    image: correnArticleImage,
    url: 'https://www.corren.se/nyheter/linkoping/artikel/robot-analyserar-valdsarenden-i-linkoping-inte-en-domare/j8m7vg4l',
    linkLabel: 'Läs artikeln',
  },
];
